import { createPinia } from "pinia";

//https://pinia.vuejs.org/core-concepts/
let pinia = createPinia();

export default pinia;
